const buttonType = {
  'DEFAULT': Symbol('default'),
  'CONFIRMATION': Symbol('confirmation'),
};

Object.freeze(buttonType);

export default buttonType;
